export const SERVER_URL =  "https://ipsitbe.instreamwealth.com/instreamdev/instream";
export const PRINCE_URL = "https://ipsit.instreamwealth.com/";


/*export const SERVER_URL = "http://localhost:8080/instreamdev/instream";
export const PRINCE_URL = "http://localhost:3000/";
*/

export const BILLING_ANNUAL_COST = 1089.0;
export const BILLING_MONTHLY_COST = 99.0;
